/**
 * Styles.
 */
import './style.scss';

/**
 * External Dependencies
 */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../../components/async-component';
import { showSocketConnectionRetryAlertMessage } from '../../../utils/alert';

/**
 * Component
 */
const TOTEM_CUSTOM_MESSAGE =
  "E' possibile che questo totem sia aperto in un altro browser o in un'altra app, anche su questo dispositivo.";

const TotemLive = () => {
  const [loading, setLoading] = useState(true);
  const [autorizzato, setAutorizzato] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const checkTotemConnesso = useCallback(totemId => {
    window.api.totem
      .checkConnesso(totemId)
      .then(res => {
        const connesso = res.data.connesso;
        if (connesso) {
          setLoading(true);
          showSocketConnectionRetryAlertMessage(
            'Totem già in uso',
            10,
            TOTEM_CUSTOM_MESSAGE
          ).then(() => {
            window.location.reload();
          });
        } else {
          if (window.socket.connected) {
            window.socket.emit('totem-hello', totemId);
          }
          window.socket.on('connect', () => {
            window.socket.emit('totem-hello', totemId);
          });
          window.socket.on('riavvio', () => {
            setTimeout(() => window.location.reload(), 1000);
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      setAutorizzato(true);
      setLoading(false);
      checkTotemConnesso(id);
    } else {
      navigate('/');
    }
  }, [id, navigate, checkTotemConnesso]);

  return (
    <div className="rui-sign align-items-center justify-content-center">
      {!loading ? (
        autorizzato ? (
          <AsyncComponent component={() => import('./content')} />
        ) : (
          <div className="rui-sign align-items-center justify-content-center">
            <p className="display-4 mb-30">Credenziali Totem Errate</p>
          </div>
        )
      ) : (
        <div className="rui-sign align-items-center justify-content-center">
          <p className="display-4 mb-30">Caricamento...</p>
        </div>
      )}
    </div>
  );
};

export default TotemLive;
